import React from 'react';
// import PointLoginLogo from './../../resources/point_club_logo.jpg'
export const InputText = (props) => {
    return(
        <input 
            style={props.style} 
            type={props.type} 
            placeholder={props.placeholder}
            id={props.id}
            className={props.class}
            maxLength={props.maxLength}
            value={props.value}
            onChange={props.onChange}
            disabled={props.disabled}
        /> 
    );
}